import { I09DIMCIRC_State } from '@batical/types/src'

const I09DIMCIRC: I09DIMCIRC_State = {
  bati_version: 1,
  name: '',
  deleted: 0,
  saveDate: 0,
  in_puissanceGenerateur: 200.0,
  in_deltaK: 15.0,
  viscosite_uuid: 'D4BD526E-015C-4A69-9BAE-0BE50917792D',
  res_debitNecessaire: 0.0,
  mode: 'none',
  calcul_code: 'I09DIMCIRC'
}

export default I09DIMCIRC
